module.exports = __webpack_public_path__ + "img/mobile-32.37579184.png";